import { AxiosInstance } from 'axios'

import { BlocksContent } from '@strapi/blocks-react-renderer'
import { MediaObject, MediaObjectList } from '../types'

export interface GetServiceCategoryPageBlocksArgs {
  locale: string
}

export type PageBlocks = {
  data: {
    id: number
    attributes: {
      all_referral_procedures_title: string
      book_now_text: string
      high_quality_title: string
      information_title: string
      interiors_title: string
      results_title: string | null
      special_offers_title: string
      specialists_in_title: string
      high_quality_images: MediaObjectList
      high_quality_text: BlocksContent
      information_image: MediaObject
      information_text: BlocksContent
      interiors_images: MediaObjectList
    }
  }
}

export const getServiceCategoryPageBlocks = async (
  client: AxiosInstance,
  { locale }: GetServiceCategoryPageBlocksArgs,
) => {
  const path = `/service-category-page-block`
  const params = {
    locale,
    fields: [
      'all_referral_procedures_title',
      'book_now_text',
      'high_quality_title',
      'information_title',
      'interiors_title',
      'results_title',
      'special_offers_title',
      'specialists_in_title',
      'high_quality_text',
      'information_text',
    ],
    populate: {
      high_quality_images: {
        fields: ['id', 'width', 'height', 'url'],
      },
      information_image: {
        fields: ['id', 'width', 'height', 'url'],
      },
      interiors_images: {
        fields: ['id', 'width', 'height', 'url'],
      },
    },
  }
  return (await client.get<PageBlocks>(path, { params })).data.data.attributes
}
